<p secondLine class="m-0">
  {{commercialCountSum + ' ' + (commercialCountSum !== 1 ? ('lang.globals.commercials' | translate) : ('lang.globals.commercial' | translate))}}
</p>
